
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { SiteModel } from './Distribution.Api.Models.Site';
import { Model, ModelProperty } from 'models/Model';


export class ServerModel extends Model<ServerModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'server.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'server.property.name' },
		{ name: 'created', type: 'Date', languageString: 'server.property.created', isHidden: true },
		{ name: 'sites', type: 'SiteModel[]', languageString: 'server.property.sites', isHidden: true, isArray: true, isObject: true, new: () => { return new SiteModel }, properties: () => { return SiteModel.classProperties } },
		{ name: 'ip', type: 'string', languageString: 'server.property.ip' },
		{ name: 'serverType', type: 'ServerType', languageString: 'server.property.serverType' }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public created?: Date;
	public sites: SiteModel[];
	public ip: string;
	public serverType: ServerType;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.created = undefined;
		this.sites = [];
		this.ip = '';
		this.serverType = 0;
		
	}
	getProperties(){
		return ServerModel.classProperties;
	}
}

export enum ServerType{
	Kubernetes = 0,
	GoCms = 1,
	WebserverApi = 2,
	Other = 3,
	ClassicAsp = 4
}
export namespace ServerType {
	export function getKeys(): Map<ServerType, string> {
		return new Map([[0, 'Kubernetes'], [1, 'GoCms'], [2, 'WebserverApi'], [3, 'Other'], [4, 'ClassicAsp']]);
	}
}
